import { Directive, Optional, ElementRef, OnInit, SimpleChange, AfterViewInit, Input } from '@angular/core';
import { AdReadonlySerivce } from '../services/adReadonly.service';
import { UntypedFormControl, NgModel, FormControlName } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[adReadonly]',
})
export class AdReadOnlyDirective implements OnInit {
  @Input('adReadonly')
  name: string;
  get isDisable() {
    return this._readonly?.isReadonly || false;
  }
  isHijected: boolean = false;
  constructor(
    @Optional() private _readonly: AdReadonlySerivce,
    @Optional() private _formControl: UntypedFormControl,
    @Optional() private _formControlName: FormControlName,
    @Optional() private _ngModel: NgModel,
    private el: ElementRef<HTMLElement>
  ) {
    this.hijectInConstructor();
  }
  ngOnChanges() {
    if (!this.isHijected) {
      this.hijectInNgOnChanges();
      this.isHijected = true;
    }
  }
  ngOnInit(): void {
    this._readonly?.readonly$.pipe(
      untilDestroyed(this)
    ).subscribe(() => this.reflectReadOnlyToHostElement());
  }


  reflectReadOnlyToHostElement() {
    if (this._formControl != null) {
      if (this.isDisable) {
        this._formControl.disable();
      } else {
        this._formControl.enable();
      }
    } else if (this._formControlName != null) {
      if (this.isDisable) {
        this._formControlName.control.disable();
      } else {
        this._formControlName.control.enable();
      }
    } else if (this._ngModel != null) {
      if (this.isDisable) {
        if (this.name?.length > 0) {
          console.log(this.name);
        }
        this._ngModel.control.disable();
      } else {
        this._ngModel.control.enable();
      }
    } else if (this.el?.nativeElement != null) {
      let { nativeElement } = this.el;
      if (nativeElement instanceof HTMLButtonElement) {
        nativeElement.disabled = this.isDisable;
      } else {
        nativeElement.style.pointerEvents = this.isDisable ? 'none' : 'unset';
        nativeElement.style.opacity = this.isDisable ? '0.2' : '1';
      }
    }
  }

  hijectInConstructor() {
    // should be hijected before ngOnChanges, so, we hijected in consturctors
    if (this._ngModel != null) {
      let originalUpdateChanges: (changes: SimpleChange) => void = (this._ngModel as any)._updateDisabled.bind(this._ngModel);
      (this._ngModel as any)._updateDisabled = (changes: SimpleChange) => {
        if (this.isDisable) {
          Promise.resolve(null).then(() => {
            this.reflectReadOnlyToHostElement();
          })
        } else {
          originalUpdateChanges(changes);
        }
      }
    }
    else if (this._formControl != null) {
      const { enable: originalEnable } = this._formControl;
      this._formControl.enable = (opts) => {
        originalEnable.call(this._formControl, opts);
        if (this.isDisable) {
          this.reflectReadOnlyToHostElement();
        }
      }
    }
  }

  hijectInNgOnChanges() {
    if (this._formControlName != null) {
      let control = this._formControlName.control;
      const { enable: originalEnable } = control;
      control.enable = (opts) => {
        originalEnable.call(control, opts);
        if (this.isDisable) {
          this.reflectReadOnlyToHostElement();
        }
      }
    }
  }
}